import "../css/Services.css";

const Services = () => {
  return (
    <main className="salon-services">

      {/* 1. HERO */}
      <section className="services-hero">
        <h1>Services</h1>
        <p>
          Thoughtfully crafted treatments,<br />
          delivered with care and precision.
        </p>
      </section>

      {/* 2. HAIR */}
      <section className="service-block">
        <div className="service-text">
          <h2>Hair</h2>
          <p>
            Precision cuts, bespoke color, and styling
            designed around your individuality.
          </p>
          <ul>
            <li>Signature Haircuts</li>
            <li>Custom Color & Balayage</li>
            <li>Styling & Finishing</li>
            <li>Treatments & Repair</li>
          </ul>
        </div>
        <div className="service-image hair-img" />
      </section>

      {/* 3. SKIN */}
      <section className="service-block reverse">
        <div className="service-text">
          <h2>Skin</h2>
          <p>
            Advanced facial treatments focused
            on restoration, glow, and balance.
          </p>
          <ul>
            <li>Signature Facials</li>
            <li>Deep Cleansing Rituals</li>
            <li>Hydration & Renewal</li>
            <li>Personalized Skin Care</li>
          </ul>
        </div>
        <div className="service-image skin-img" />
      </section>

      {/* 4. NAILS */}
      <section className="service-block">
        <div className="service-text">
          <h2>Nails</h2>
          <p>
            Clean, minimal nail care
            with an emphasis on health.
          </p>
          <ul>
            <li>Manicure & Pedicure</li>
            <li>Gel & Natural Finish</li>
            <li>Cuticle Care</li>
          </ul>
        </div>
        <div className="service-image nails-img" />
      </section>

      {/* 5. BRIDAL */}
      <section className="service-block reverse">
        <div className="service-text">
          <h2>Bridal & Events</h2>
          <p>
            Bespoke beauty services for
            weddings and special occasions.
          </p>
          <ul>
            <li>Bridal Hair & Makeup</li>
            <li>Trial Sessions</li>
            <li>On-location Services</li>
          </ul>
        </div>
        <div className="service-image bridal-img" />
      </section>

      {/* 6. CLOSING */}
      <section className="services-closing">
        <p>
          Luxury is not rushed.<br />
          Every service is intentional.
        </p>
      </section>

    </main>
  );
};

export default Services;
